import React from "react";
import { graphql, Script, withAssetPrefix } from "gatsby";
import { AdobeAnalyticsAdobeConfigFragment } from "../../graphql-types";

function getQueryStringValue(needle: string): string {
  const haystack: Record<string, string> = {};

  window.location.search
    .substring(1)
    .split("&")
    .forEach(function (item) {
      const [key, value] = item.split("=");
      haystack[key] = value;
    });

  return haystack[needle];
}

export function trackAnalytics() {
  if (window.digitalData) {
    window.s?.t();
    // fire any event callbacks registered added here
    window.digitalData.adobeEvents.forEach((fn) => fn());

    const unileverId = getQueryStringValue("eulid");
    if (unileverId && window.s?.visitor && window.Visitor?.AuthState) {
      window.s.visitor.setCustomerIDs({
        eULID: {
          id: unileverId,
          authState: window.Visitor.AuthState.AUTHENTICATED,
        },
      });
    }
  }
}

window.trackAnalytics = trackAnalytics;

type Props = {
  adobeConfig: AdobeAnalyticsAdobeConfigFragment;
};

export default function AdobeAnalytics({
  adobeConfig: {
    analytics__adobe__account,
    analytics__adobe__trackingServer,
    analytics__adobe__trackingServerSecure,
    analytics__adobe__reportSuiteId,
    analytics__adobe__containerId,
    analytics__adobe__region,
    analytics__adobe__language,
  },
}: Props) {
  return (
    <>
      <Script id="adobe-analytics-config">
        {`
            window.adobeConfig = ${JSON.stringify(
              {
                analytics__adobe__account,
                analytics__adobe__trackingServer,
                analytics__adobe__trackingServerSecure,
                analytics__adobe__reportSuiteId,
                analytics__adobe__containerId,
                analytics__adobe__region,
                analytics__adobe__language,
                analytics__adobe__audienceManagementPartner: "unilever",
              },
              null,
              2
            )}
          `}
      </Script>
      <Script
        defer
        src={withAssetPrefix(
          "__analytics/Adobe-538a4d596bf7336ee0cf86614cdec8c0.min.js"
        )}
      />
    </>
  );
}

export const fragments = {
  adobeConfig: graphql`
    fragment AdobeAnalyticsAdobeConfig on AdobeConfig {
      analytics__adobe__account: account
      analytics__adobe__trackingServer: trackingServer
      analytics__adobe__trackingServerSecure: trackingServerSecure
      analytics__adobe__reportSuiteId: reportSuiteId
      analytics__adobe__containerId: containerId
      analytics__adobe__region: region
      analytics__adobe__language: language
    }
  `,
};
